<script>
import Repositories from '@/repositories';
const WorkOrderItemsRepository = Repositories.get('workorderitems');
import dateMixin from '@/mixins/dateMixin';
export default {
  props: {
    typeItem: Number,
    workOrderItem: Object,
    nbItemsLeft: Number,
  },
  mixins: [dateMixin],
  methods: {
    reserveItems() {
      let apiWrapper = {
        reservedQuantity:
          this.nbItemsLeft < this.workOrderItem.requestedQuantity
            ? this.nbItemsLeft
            : this.workOrderItem.requestedQuantity,
      };
      WorkOrderItemsRepository.customREST
        .reserveRequested(apiWrapper, this.workOrderItem.idPublic)
        .then((resp) => {
          if (resp.data != null) {
            this.$emit('wo-item-remove', resp.data);
          } else {
            this.$emit('error-connection', 2);
          }
        })
        .catch((error) => {
          if (error.response.status == 409) {
            this.$emit('error-connection', 1);
          } else {
            this.$emit('error-connection', 2);
          }
        });
    },
    requestInstead() {
      this.changeReservation(true);
    },
    cancelReservation() {
      this.changeReservation(false);
    },
    changeReservation(requestInstead) {
      WorkOrderItemsRepository.actions
        .cancelReservation(
          { requestInstead: requestInstead },
          this.workOrderItem.idPublic
        )
        .then((resp) => {
          if (resp.data != null) {
            this.$emit('wo-item-remove', resp.data);
          } else {
            this.$emit('error-connection', 2);
          }
        })
        .catch((error) => {
          if (error.response.status == 409) {
            this.$emit('error-connection', 1);
          } else {
            this.$emit('error-connection', 2);
          }
        });
    },
  },
  computed: {
    workOrderItemQuantity() {
      if (this.typeItem == 1) {
        return this.workOrderItem.reservedQuantity;
      } else if (this.typeItem == 2) {
        return this.workOrderItem.requestedQuantity;
      } else {
        return 0;
      }
    },
  },
};
</script>


<template>
  <tr>
    <td class="table-row-expandable">
      {{ workOrderItem.workOrderName }}
    </td>
    <td class="table-row-relative">
      {{ formatDate(workOrderItem.workOrderDeliveryDate) }}
    </td>
    <td class="table-row-relative">
      {{ workOrderItemQuantity }}
    </td>
    <td class="table-row-relative">
      <b-dropdown
        v-if="typeItem == 1"
        dropleft
        class="card-drop"
        variant="link"
        toggle-class="text-decoration-none p-0"
        no-caret
      >
        <template #button-content>
          <i class="fas fa-ellipsis-h" />
        </template>
        <b-dropdown-item @click="requestInstead()">
          <i class="fas fa-pen text-success mr-1"></i>
          {{ $t('items.requestInstead') }}
        </b-dropdown-item>

        <b-dropdown-item @click="cancelReservation()">
          <i class="fas fa-trash-alt text-danger mr-1"></i>
          {{ $t('items.cancelReservation') }}
        </b-dropdown-item>
      </b-dropdown>

      <b-dropdown
        v-if="typeItem == 2"
        dropleft
        class="card-drop"
        variant="link"
        toggle-class="text-decoration-none p-0"
        no-caret
      >
        <template #button-content>
          <i class="fas fa-ellipsis-h" />
        </template>
        <b-dropdown-item @click="reserveItems()">
          <i class="fas fa-pen text-success mr-1"></i>
          {{ $t('items.reserveItems') }}
        </b-dropdown-item>
      </b-dropdown>
    </td>
  </tr>
</template>